import React from 'react';
import { MapPin, Clock, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3
              className="text-3xl font-bold text-[#C1272D] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Obrador Pomodoro
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Una experiencia italiana auténtica en el corazón de Rosario. 
              Pasión por la cocina, dedicación en cada plato.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#about"
                  className="text-gray-400 hover:text-[#C1272D] transition-colors"
                >
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a
                  href="#menu"
                  className="text-gray-400 hover:text-[#C1272D] transition-colors"
                >
                  Menú
                </a>
              </li>
              <li>
                <a
                  href="#reviews"
                  className="text-gray-400 hover:text-[#C1272D] transition-colors"
                >
                  Opiniones
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-gray-400 hover:text-[#C1272D] transition-colors"
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contacto</h4>
            <div className="space-y-3 text-gray-400">
              <a
                href="https://www.google.com/maps/search/?api=1&query=Obrador+Pomodoro+Rosario"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 hover:text-[#C1272D] transition-colors"
              >
                <MapPin className="flex-shrink-0 mt-1" size={18} />
                <p>Brown 2408, Rosario, Santa Fe</p>
              </a>
              <div className="flex items-start gap-3">
                <Clock className="flex-shrink-0 mt-1" size={18} />
                <p>Martes a domingo<br />12:00 - 01:00</p>
              </div>
              <a
                href="https://instagram.com/obra.pomodoro"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:text-[#C1272D] transition-colors"
              >
                <Instagram className="flex-shrink-0" size={18} />
                <p>@obra.pomodoro</p>
              </a>
            </div>

            {/* Social Media */}
            <div className="mt-6">
              <p className="text-sm font-semibold mb-3">Seguinos</p>
              <div className="flex gap-4">
                <a
                  href="https://instagram.com/obra.pomodoro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C1272D] transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={20} />
                </a>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Obrador+Pomodoro+Rosario"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#C1272D] transition-colors"
                  aria-label="Ver en Google Maps"
                >
                  <MapPin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400 text-sm">
          <p>
            © {currentYear} Obrador Pomodoro. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
